import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-detalle-reporte-asistencia',
  templateUrl: './detalle-reporte-asistencia.component.html',
  styleUrls: ['./detalle-reporte-asistencia.component.css']
})
export class DetalleReporteAsistenciaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
